var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7221 -1915)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5548.543 1498.607)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 0.5,
    transform: "translate(1672.457 416.393)",
    fill: "#e3eeff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1677.457 418.393)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.423 0.394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.841,28.021l-.563.375-.938-.188-.563-.188-.75.188-.563-.188.375-.75h.75l.735-.368A5.371,5.371,0,0,1,285.841,28.021Z",
    transform: "translate(-276.888 -26.727)",
    fill: "#03aa6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.556,19.148l-.188.563-.563.188-.563.938-.938.563-1.313.188v.563l.375.375v.75L20.8,22.9l-.563-.375-.326-.981A5.435,5.435,0,0,1,22.9,18.6l.533.356Z",
    transform: "translate(-19.916 -18.604)",
    fill: "#03aa6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.528,213.629l-.188.938-.75.75v.563l-.75.563v.938l-.563-.188-.375-.938v-1.875l-.938-.188-.375-.75v-.563l.375-.375.563-.563.375.75h1.313l.563.938Z",
    transform: "translate(-69.514 -207.834)",
    fill: "#03aa6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.009,115.173a5.433,5.433,0,0,1-.3,5.789l-.506-.506v-.75l-.375-.75-.375-.75v-.75l-.563-.375-.75.188-1.313-.563-.188-1.313.563-.563h1.125l.375.563,1.125.188,1.125-.375Z",
    transform: "translate(-268.249 -112.786)",
    fill: "#03aa6f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.563,1.942l.75-.188.563.188.938.188.563-.375a5.356,5.356,0,0,1,.806,1.093l-.056.032L9,3.255,7.876,3.067,7.5,2.5H6.376l-.563.563L6,4.38l1.313.563.75-.188.563.375v.75L9,6.63l.375.75v.75l.506.506A5.439,5.439,0,0,1,.423,3.4l.326.981.563.375.563.375L1.5,5.505v.563l.375.75.938.188V8.881l.375.938.563.188V9.068l.75-.563V7.943l.75-.75.188-.938h-.75l-.563-.938H2.812l-.375-.75-.563.563V4.38L1.5,4V3.442l1.313-.188.938-.563.563-.938.563-.188L5.063,1,3.938.817,3.4.46A5.439,5.439,0,0,1,7.861.637L7.126,1h-.75L6,1.754Z",
    transform: "translate(0 -0.067)",
    fill: "#86daf1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.b1b60105c896bb624a424a8025d82db4.svg";
export { ForwardRef as ReactComponent };